import React, {useEffect, useState} from "react";

import { BADGE_IMAGE, BADGE_COORDINATE, BACKGROUND_WIDTH, BACKGROUND_HEIGHT, BADGE_TYPE } from "../../services/badging/constants";
const ASPECT_RATIO = BACKGROUND_WIDTH / BACKGROUND_HEIGHT;

export default function BadgeGrid(props) {
  const { badges } = props;

  // scale is used to render the badge grid responsively depending on window dimensions
  const [scale, setScale] = useState(1);

  useEffect(() => {
    getGridScale();
    window.addEventListener('resize', getGridScale);
    return () => window.removeEventListener('resize', getGridScale);
  }, [])

  // computes the scale of the grid based on window dimensions
  function getGridScale() {
    const trueBackgroundHeight = Math.max(innerHeight, innerWidth * 1/ASPECT_RATIO);
    setScale(trueBackgroundHeight / BACKGROUND_HEIGHT);
  }

  const getBadgeGridItem = (badge) => {
    const { rewardLevelId, badgeTypeId, awardedAt, locale } = badge;
    const badgeCoords = BADGE_COORDINATE[badge.badgeTypeId]?.[badge.locale]?.[badge.rewardLevelId] || {};
    const badgeImage = BADGE_IMAGE[badge.locale][badge.rewardLevelId];
    const dataTip = {
      rewardLevelId,
      badgeTypeId,
      awardedAt,
      locale,
    };
    const badgeGridItem = (
      <a className="badgeGridItem" key={badge.id} data-tip={JSON.stringify(dataTip)} data-for="badgingFlyover" style={badgeCoords}>
        <img className="badgeGridImage" src={badgeImage} style={{height: 70 * scale}} alt={`${rewardLevelId} badge`} />
      </a>
    );
    return badgeGridItem;
  };

  const getBadgeGridSection = (badgeTypeId) => {
    const badgesOfType = badges.filter((badge) => badge.badgeTypeId === badgeTypeId && badge.awarded);
    const badgeGridSection = badgesOfType.map((badge) => getBadgeGridItem(badge));
    return badgeGridSection;
  };

  return (
    <div className="badgeGrid" style={{ height: BACKGROUND_HEIGHT * scale, width: BACKGROUND_WIDTH * scale}}>
      <div className="badgeGridSection">
        {getBadgeGridSection(BADGE_TYPE.NUM_SESSIONS)}
        {getBadgeGridSection(BADGE_TYPE.NUM_MINUTES)}
        {getBadgeGridSection(BADGE_TYPE.NEW_WCPM_HIGH)}
        {getBadgeGridSection(BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION)}
        {getBadgeGridSection(BADGE_TYPE.NEW_HIGH)}
        {getBadgeGridSection(BADGE_TYPE.CUSTOM)}
      </div>
    </div>
  );
}
